import { string } from "prop-types";
import { SideContainer, WidgetContainer } from "../UI/Containers";
import Divider from "../UI/Divider";
import AutoPlans from "./AutoPlans";
import Dates from "./Dates";
import Marketing from "./Marketing";
import { tdpDetails } from "../../shared/HOCs/withRedux";
import { TYPE } from "../../shared/reduxRoutes/tdpDetailsRoutes";
import { useFeatureFlags } from "../../reducers/layoutReducer/selectors";
import { isReferral } from "../shared/helpers";
import TitleAndEscrow from "./TitleAndEscrow";

const ReferralSideRight = () => (
  <SideContainer>
    <div className="tw-block">
      <WidgetContainer>
        <Dates />
      </WidgetContainer>
      <Divider />
      <WidgetContainer>
        <AutoPlans />
      </WidgetContainer>
    </div>
  </SideContainer>
);

const NonReferralSideRight = ({ type }) => {
  const featureFlags = useFeatureFlags();
  return (
    <SideContainer>
      <div className="tw-block">
        <WidgetContainer>
          <Dates />
        </WidgetContainer>
        <Divider />
        {featureFlags.blueprintTitle && (type === "buyer" || type === "seller") && (
          <>
            <WidgetContainer>
              <TitleAndEscrow />
            </WidgetContainer>
            <Divider />
          </>
        )}
        <WidgetContainer>
          <AutoPlans />
        </WidgetContainer>
        <Divider />
        <WidgetContainer>
          <Marketing />
        </WidgetContainer>
      </div>
    </SideContainer>
  );
};

const SideRight = ({ type }) =>
  !isReferral(type) ? <NonReferralSideRight type={type} /> : <ReferralSideRight />;

SideRight.propTypes = {
  type: string,
};

SideRight.defaultProps = {
  type: null,
};
export default tdpDetails({ WrappedComponent: SideRight, states: TYPE });
